import React from "react";
import { Trans } from "@lingui/macro";
import { CustomerReviews } from "../../../components/Reviews";

const ReviewsSection = ({
  cityId,
  overallCount,
  isMobileView,
  lang,
  attractionId,
  attractionName,
  cityName,
}) => {
  if (!cityId) return null;

  return (
    <CustomerReviews
      showOverallRating
      overallCount={overallCount}
      withPopup={isMobileView}
      lang={lang}
      isMobile={isMobileView}
      queryParams={{ attractionId }}
      title={<Trans>What people say about {attractionName || cityName}</Trans>}
    />
  );
};

export default ReviewsSection;
